import { createTableSlice } from '../helpers';
import { TaskStatus } from '../../constants';

export const tableSlice = createTableSlice({
  name: 'finishedTable',
  url: '/api/labelTasks',
  filters: {
    status: TaskStatus.FINISHED,
    all: 1,
  },
  sortOrder: 'desc',
  orderBy: 'LabelTask.id',
});
